export const configcode = {
  debug: false, //enable console.log
  // ------------- Development Settings ----------------
  api: "dev",
  baseSelfUrl: "https://frontend-dev.saijai-crm.com",

  //base saijai commission api url
  baseUrl: "https://backend-dev.saijai-crm.com",

  //base saijai pos web url
  basePOSUrl: "https://saijaipos-dev.saijai-crm.com",

  //base saijai api blob url
  bzbsBlobUrl: "https://devstoragebuzzebees.blob.core.windows.net",
  basePublic: "https://public-dev.saijai-crm.com",
  themeVersion: 3,
};
